export const blockIconsBusinessandpaymentsAccountTreeNew = (
	<span className='material-symbols-outlined'>account_tree</span>
);
